<div class="container-fluid insight-container">
    <div class="row">
        <div class="insight-component-wrapper">
            <ng-container *ngFor="let c of _config?.cards">
                <div
                    class="insight-component-child"
                    cmpsCoachingCardRep
                    *ngIf="c.name === _Cards.COACHING_REP"
                ></div>
                <div
                    class="insight-component-child"
                    cmpsMyCoachingCard
                    *ngIf="c.name === _Cards.COACHING"
                ></div>
                <div
                    class="insight-component-child"
                    cmpsMyPerformanceCard
                    *ngIf="c.name === _Cards.PERFORMANCE"
                ></div>
                <div
                    class="insight-component-child"
                    cmpsMyScorecard
                    *ngIf="c.name === _Cards.SCORECARD"
                ></div>
            </ng-container>
        </div>
    </div>
</div>
